import stripeExternalAccountListStore from '@modules/stripe/stripe-external-account/stripe-external-account-list-store';
import stripeExternalAccountViewStore from '@modules/stripe/stripe-external-account/stripe-external-account-view-store';
import stripeExternalAccountFormStore from '@modules/stripe/stripe-external-account/stripe-external-account-form-store';

export default {
  namespaced: true,

  modules: {
    form: stripeExternalAccountFormStore,
    list: stripeExternalAccountListStore,
    view: stripeExternalAccountViewStore
  },
};
